import React, { useState, useEffect } from "react";
import {
  Typography,
  IconButton,
  CircularProgress,
  LinearProgress,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import StopIcon from "@material-ui/icons/Stop";
import { Alert } from "@material-ui/lab";
import { get, first, keys, sumBy, find, filter } from "lodash";
import { formatDuration } from "date-fns";

import "./style.css";
import { api_root, request, downloadImage } from "../requests";

const AssetsList = ({
  assetsStatus,
  currentlyPlaying,
  startPlayTime,
  timeInterval,
  currentProgress,
  setTimeInterval,
  togglePlay,
}) => {
  const location = useLocation();
  const [device_id, setDeviceId] = useState();
  const [images, setImages] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const promises = [];
    const data = {};
    assets.forEach(({ matched_media, _id }) => {
      promises.push(
        new Promise((resolve) => {
          downloadImage(
            `${api_root}/assets/${get(
              matched_media[first(keys(matched_media))],
              "id"
            )}/thumbnail`
          ).then((image) => {
            data[_id] = image;
            resolve();
          });
        })
      );
    });
    Promise.all(promises).then(() => {
      setImages(data);
    });
  }, [assets]);

  // Collect the player's id
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    setDeviceId(urlParams.get("id"));
  }, [location]);

  // Load playlist data at launch
  useEffect(() => {
    if (device_id) {
      setLoading(true);
      request({
        type: "playlists",
        method: "get",
        value: { device_id },
      })
        .then(({ data, error }) => {
          setLoading(false);
          if (!error && data) {
            setAssets(
              filter(data, ({ program: { type } }) => type === "trigger")
            );
          }
        })
        .catch(({ message }) => {
          setError(message);
          setLoading(false);
        });
    }
  }, [device_id]);

  const togglePlaySend = (id) => {
    togglePlay(id, assets);
  };

  // Start the playing status
  useEffect(() => {
    if (currentlyPlaying && startPlayTime) {
      const matched_media = get(
        find(assets, ({ _id }) => _id === currentlyPlaying),
        "matched_media"
      );
      const duration = parseInt(
        sumBy(keys(matched_media), (key) =>
          get(matched_media, `[${key}].duration`)
        )
      );
      if (!timeInterval) {
        setTimeInterval(duration, device_id);
      }
    }
  }, [
    startPlayTime,
    timeInterval,
    currentlyPlaying,
    assets,
    setTimeInterval,
    device_id,
  ]);

  return (
    <div className="AssetsList">
      <Typography variant="h4">Playlists</Typography>
      {error && <Alert severity="error">{error}</Alert>}

      {loading && (
        <center>
          <CircularProgress />
        </center>
      )}

      {!loading && (
        <div className="container">
          {assets.map(({ _id, program: { name }, matched_media }) => (
            <div
              key={`asset${_id}`}
              className="asset"
              onClick={togglePlaySend.bind(this, _id)}
            >
              <div
                className="thumbnail"
                style={{
                  backgroundImage: `${
                    images[_id]
                      ? `url(data:image/png;base64,${images[_id]})`
                      : "/"
                  }`,
                }}
              />
              <div className="content">
                <Typography variant="body1">{name}</Typography>
                <Typography variant="caption">
                  {formatDuration(
                    {
                      seconds: parseInt(
                        sumBy(keys(matched_media), (key) =>
                          get(matched_media, `[${key}].duration`)
                        ) / 1000
                      ),
                    },
                    { format: ["minutes", "seconds"], delimiter: ":" }
                  )}
                </Typography>
                {_id === currentlyPlaying && (
                  <LinearProgress
                    variant="determinate"
                    value={parseInt(currentProgress)}
                  />
                )}
              </div>
              <div className="actionContainer">
                <IconButton>
                  {get(assetsStatus, `[${_id}]`) === true ? (
                    <StopIcon />
                  ) : (
                    <PlayCircleFilledIcon />
                  )}
                </IconButton>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AssetsList;
